export const PROJECT_WITH_NATIONS = 'projectWithNations';

export const PROJECT_WITH_NATIONS_ACTIONS_NAME = {
  searchProjects: `${PROJECT_WITH_NATIONS}/searchProjects`,
  getProjectsInForeignCountriesDatesCount: `${PROJECT_WITH_NATIONS}/getProjectsInForeignCountriesDatesCount`,
  setIsLoadingCount: `${PROJECT_WITH_NATIONS}/setIsLoadingCount`,
} as const;

export const PROJECT_WITH_NATIONS_MUTATIONS_NAME = {
  setListOfProjects: `${PROJECT_WITH_NATIONS}/setListOfProjects`,
  setProjectsInForeignCountriesDatesCount: `${PROJECT_WITH_NATIONS}/setProjectsInForeignCountriesDatesCount`,
  setIsLoadingCount: `${PROJECT_WITH_NATIONS}/setIsLoadingCount`,
} as const;

export const PROJECT_WITH_NATIONS_GETTERS_NAME = {
  getListOfProjects: `${PROJECT_WITH_NATIONS}/getListOfProjects`,
  getProjectsInForeignCountriesDatesCount: `${PROJECT_WITH_NATIONS}/getProjectsInForeignCountriesDatesCount`,
  getIsLoadingCount: `${PROJECT_WITH_NATIONS}/getIsLoadingCount`,
} as const;
